export const serverUrl = process.env.REACT_APP_SERVER_URL
export const clientUrl = process.env.REACT_APP_CLIENT_URL

const localAuthDomain = "http://localhost:9099"
export const authDomain = process.env.REACT_APP_AUTH_DOMAIN
export const environment = process.env.REACT_APP_ENVIRONMENT

export const toastErrorConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}
